import { ReceiverCategoryOptions, ReceiveRequestOptions } from "@pages/candidate/detail/CandidateContactPoint";

export const CddMeCheckStatus = {
    YES: { id: 1, title: 'YES' },
    NO: { id: 2, title: 'NO' },
    PERSON_REQUEST_SEND_TO_OTHER_EMAIL: { id: 3, title: 'Person đề nghị gửi sang email khác' }
}

export const CddMeCheckStatusOptions = Object.values(CddMeCheckStatus).map(item => {
    return {
        value: item.id,
        label: item.title
    };
})

export const InteractiveChannel = [
    "",
    // "Us emailed mời job",
    "Us emailed",
    "Us called",
    "Us chatted",
    "Person emailed",
    "Person called",
    "Person chatted",
    "Met",
    "User emailed FU Rec đinh kỳ",
    "User emailed đn Rec update info đinh kỳ",
    "Others",
]

export const InteractiveChannelOptions = InteractiveChannel.map(item => {
    return {
        value: item,
        label: item
    };
})

export const GpCddProcess = {
    BLANK: "",
    GP_TARGET_CDD: "GP target Cdd",
    GP_INVITE_DVTJCUV: "GP mời DVTJCUV",
    GP_FOLLOWING_UP: "GP Following up",
    CALL_KHONG_LIEN_LAC_DUOC: "Call không liên lạc được",
    CDD_TU_CHOI_CUNG_CAP_EMAIL: "Cdd từ chối cung cấp email",
    CDD_REPLY_EMAIL_INVITE_DVTJCUV: "Cdd phản hồi email mời DVTJCUV",
    CDD_HOI_THONG_TIN: "Cdd hỏi thông tin",
    CDD_DANG_CAN_NHAC: "Cdd đang cân nhắc",
    CDD_HUA_PHAN_HOI: "Cdd hứa phản hồi",
    CDD_HUA_GUI_CV: "Cdd hứa gửi CV",
    CDD_REJECT: "Cdd từ chối",
    CDD_AGREE_TO_COOPERATE: "Cdd đồng ý hợp tác",
    DISCUSS_AGREEMENT: "Trao đổi về Agreement",
    CDD_CONFIRM_AGREEMENT: "Cdd confirm Agreement",
    CDD_DISAGREE_AGREEMENT: "Cdd không đồng ý Agreement",
    AGREEMENT_DONE: "Agreement Done",
    SERVICE_ACTIVATED: "Service activated",
    // CDD_ACTIVATION_FEE_PAYMENT: "Cdd thanh toán phí kích hoạt",
    CDD_INTERVIEW: "Phỏng vấn Cdd",
    CHECK_REF: "Check Ref",
    BRIEF_DONE: "Brief done",
    // CDD_STOP_USING_DVTJCUV: "Cdd ngừng sử dụng DVTJCUV",
    BRIEF_NOT_DONE: "Brief not done",
    SERVICE_PAUSED: "Service paused",
    SERVICE_RE_ACTIVATED: "Service re-activated",
    SERVICE_EXPIRED: "Service expired",
    OTHERS: "Others"
};

export const GpCddProcessOptions = Object.values(GpCddProcess).map(item => {
    return {
        value: item,
        label: item
    };
})

export const UsQualifyCdd = [
    "",
    "Động lực chuyển việc chưa đủ mạnh",
    "Chưa đủ thiện chí hợp tác với GP",
    "Chất lượng chưa phù hợp để gth cho các Emp",
    "Others"
]

export const UsQualifyCddOptions = UsQualifyCdd.map(item => {
    return {
        value: item,
        label: item
    };
})

export const TodoWCdd = {
    BLANK: "",
    TO_CALL: "To call",
    TO_CHAT: "To chat",
    TO_MEET: "To meet",
    TO_ME_FOLLOW_UP: "To ME follow up",
    TO_FOLLOW_UP: "To follow up",
    TO_REP: "To rep",
    NEED_TO_FIND_MORE_EMP: "Need to find more Emp",
    PENDING: "Pending",
    IGNORE: "Ignore",
    DONE_PROCESS_W_DVTJCUV: "Done process w DVTJCUV",
    PAUSE_PROCESS_W_DVTJCUV: "Tạm dừng process DVTJCUV",
    PAUSE_CONNECT_W_EMPS: "Tạm dừng kết nối với Emps",
    OTHERS: "Others"
};

export const TodoWCddSortOrder = [
    "To call",
    "To chat",
    "To follow up",
    "To meet",
    "To rep",
    "Others",
    "Pending",
    "Ignore",
    "Done process w DVTJCUV",
]


export const TodoWCddOptions = Object.values(TodoWCdd).map(item => {
    return {
        value: item,
        label: item
    };
})

export const InviteSendJobTodoWRec = {
    BLANK: "",
    TO_CALL: "To call",
    TO_CHAT: "To chat",
    TO_MEET: "To meet",
    TO_ME_FOLLOW_UP: "To ME follow up",
    TO_FOLLOW_UP: "To follow up",
    TO_REP: "To rep",
    PAUSE_INVITE_SEND_JOB: "Tạm dừng mời gửi job",
    OTHERS: "Others"
};

export const InviteSendJobTodoWRecOptions = Object.values(InviteSendJobTodoWRec).map(item => {
    return {
        value: item,
        label: item
    };
})


export const GpEmpProcess = [
    "",
    "mời",
    "cân nhắc / đang trao đổi",
    "đồng ý",
    "từ chối",
]

export const GpEmpProcessOptions = GpEmpProcess.map(item => {
    return {
        value: item,
        label: item
    };
})

export const InviteSendJobGpEmpProcess = [
    "Target",
    "User emailed mời Rec gửi job",
    "User mời Rec gửi job ((call chat..))",
    "User emailed FU",
    "User FU ((call chat..))",
    "Rec cân nhắc / đang trao đổi",
    "Rec đồng ý",
    "Rec từ chối",
    "Rec gửi job",
    "Rec giới thiệu cho Rec khác",
    "Others",
];

export const InviteSendJobGpEmpProcessOptions = InviteSendJobGpEmpProcess.map(item => {
    return {
        value: item,
        label: item
    };
})

export const MatchingPotential = [
    "",
    "Very Potential",
    "Potential",
    "Not potential",
    "Others"
]

export const MatchingPotentialOptions = MatchingPotential.map(item => {
    return {
        value: item,
        label: item
    };
})

export const CddEmpProcess = [
    "",
    "Target",
    "Brief sent",
    "Emp quan tâm ƯV, muốn trao đổi thêm",
    "Emp quan tâm ƯV, nhưng không muốn share job",
    "Emp không quan tâm ƯV này",
    "No suitable job now",
    "Emp share job",
    "Cdd reject Employer",
    "Cdd reject Job",
    "Cdd's CV sent",
    "Emp rejects CV",
    "Emp keep CV in view",
    "Emp invites Cdd to ITV",
    "Cdd Rejects ITV",
    "Interviewing",
    "Interviewed (successful)",
    "Interviewed (not successful)",
    "Cdd làm bài tập, presentation,…",
    "Thủ tục trước khi offer (Ref Check, Pay slip,…)",
    "Verbal Offer",
    "Official Offer",
    "Cdd rejects Offer",
    "Cdd accepts Offer",
    "Cdd onboard",
    "Emp cancel offer",
    "Cdd not onboard",
    "Others"
]

export const CddEmpProcessOptions = CddEmpProcess.map(item => {
    return {
        value: item,
        label: item
    };
})

export const CddEmpFuNeeded = [
    "",
    "To rep Cdd",
    "To rep Emp",
    // "Find more Emp to match",
    "Follow up Cdd",
    "Follow up Emp",
    "Process Ended",
    "Others"
]

export const CddEmpFuNeededOptions = CddEmpFuNeeded.map(item => {
    return {
        value: item,
        label: item
    };
})

export const PaymentAndWarranty = [
    "",
    "Start",
    "Cdd confirmed",
    "Emp confirmed",
    "Issue Draft invoice",
    "Draft invoice confirmed",
    "Issue Invoice",
    "Chờ thanh toán",
    "Client paid partly",
    "Client paid all",
    "Finish Guarantee",
    "Cdd leave",
    "Employer dismissed Cdd",
    "Client request Refund",
    "Refund done",
    "Client request Cdd Replacement",
    "Cdd Replacement done",
    "Others",
]

export const PaymentAndWarrantyOptions = PaymentAndWarranty.map(item => {
    return {
        value: item,
        label: item
    };
})


export const GdTTBHFuNeeded = [
    "",
    "Follow up Cdd",
    "Follow up Emp",
    "Process Ended",
    "Others"
]

export const GdTTBHFuNeededOptions = GdTTBHFuNeeded.map(item => {
    return {
        value: item,
        label: item
    };
})

export const ProcessPriority = {
    BLANK: { value: "", label: "" },
    YES: { value: "1", label: "Có" },
    NO: { value: "2", label: "Không" }
}

export const ProcessPriorityOptions = Object.values(ProcessPriority)

export const ReceiverCommentCddOptions = [
    { value: "", label: "" },
    { value: "UV này chưa phù hợp với Emp", label: "UV này chưa phù hợp với Emp" },
    { value: "UV này chưa đủ tầm với Emp", label: "UV này chưa đủ tầm với Emp" },
    { value: "Good feedback", label: "Good feedback" },
    { value: "UV này tệ / không ổn", label: "UV này tệ / không ổn" },
]

export const JobFindMode = {
    BLANK: { value: "", label: "" },
    ON: { value: "1", label: "ON" },
    OF: { value: "2", label: "OFF" }
}

export const JobFindModeOptions = Object.values(JobFindMode).map(item => {
    return item;
})

// Kho pipeline
export const DVTJCUVPipelineTableColumns = [
    {
        key: 'created_date_time',
        label: 'Note time',
        classNames: '',
        displayType: 'text',
        inputType: 'date',
        editable: false,
        autoAdd: true,
        searchable: false,
        group: 1,
    },
    {
        key: 'created_user_name',
        label: 'Created user',
        classNames: '',
        displayType: 'text',
        inputType: 'text',
        editable: false,
        autoAdd: true,
        searchable: false,
        group: 1,
    },
    {
        key: 'id',
        label: 'Pipeline ID',
        classNames: '',
        displayType: 'text',
        inputType: 'number',
        editable: false,
        autoAdd: true,
        searchable: true,
        group: 1,
    },
    {
        key: 'cdd_id',
        label: 'Cdd ID',
        classNames: '',
        displayType: 'link',
        inputType: 'number',
        editable: true,
        link: '/candidate/detail/',
        searchable: true,
        group: 2,
    },
    {
        key: 'dvtjcuv_client_id',
        label: 'Cdd ID (DVTJCUV)',
        classNames: '',
        displayType: 'text',
        inputType: 'number',
        editable: true,
        searchable: true
    },
    {
        key: 'cdd_full_name',
        label: 'Họ và tên',
        classNames: '',
        displayType: 'text',
        inputType: 'text',
        editable: false,
        autoAdd: true,
        capitalize: true,
        searchable: false,
        group: 2,
    },
    {
        key: 'cdd_displayed_company',
        label: 'Displayed Company',
        classNames: '',
        displayType: 'text',
        inputType: 'text',
        editable: false,
        capitalize: true,
        autoAdd: true,
        searchable: false,
        group: 2,
    },
    {
        key: 'cdd_displayed_title',
        label: 'Displayed Title',
        classNames: '',
        displayType: 'text',
        inputType: 'text',
        editable: false,
        capitalize: true,
        autoAdd: true,
        searchable: false,
        group: 2,
    },
    {
        key: 'cdd_local_province_email',
        label: 'Loca tỉnh (email)',
        classNames: '',
        displayType: 'text',
        inputType: 'text',
        editable: false,
        capitalize: true,
        autoAdd: true,
        searchable: false,
        group: 2,
    },
    {
        key: 'cdd_industry',
        label: 'Industry',
        classNames: '',
        displayType: 'text',
        inputType: 'text',
        editable: false,
        capitalize: true,
        autoAdd: true,
        searchable: false,
        group: 2,
    },
    {
        key: 'cdd_function',
        label: 'Function',
        classNames: '',
        displayType: 'text',
        inputType: 'text',
        editable: false,
        capitalize: false,
        autoAdd: true,
        searchable: false,
        group: 2,
    },
    {
        key: 'current_find_job_mode',
        label: 'Chế độ tìm job',
        classNames: '',
        displayType: 'text',
        inputType: 'option',
        editable: false,
        isMulti: false,
        options: JobFindModeOptions,
        capitalize: true,
        autoAdd: true,
        searchable: false,
        group: 2,
    },
    {
        key: 'current_find_job_mode_note_time',
        label: 'Note time (Chế độ tìm job)',
        classNames: '',
        displayType: 'text',
        inputType: 'date',
        editable: false,
        capitalize: true,
        autoAdd: true,
        searchable: false,
        group: 2,
    },
    {
        key: 'service_use_times',
        label: 'Lần SD dịch vụ',
        classNames: '',
        displayType: 'text',
        inputType: 'number',
        editable: false,
        capitalize: false,
        autoAdd: true,
        searchable: true,
        group: 3,
    },
    {
        key: 'cdd_me_check_status',
        label: 'Trạng thái check ME của Cdd',
        classNames: '',
        displayType: 'text',
        inputType: 'option',
        searchable: true,
        editable: true,
        isMulti: false,
        options: CddMeCheckStatusOptions,
        color: '',
        group: 3,
    },
    {
        key: 'interactive_channel',
        label: 'Loại tương tác',
        classNames: '',
        displayType: 'text',
        inputType: 'option',
        searchable: true,
        editable: true,
        isMulti: false,
        options: InteractiveChannelOptions,
        color: '',
        group: 3,
    },
    {
        key: 'gp_cdd_process',
        label: 'GP-Cdd Process (DVTJCUV)',
        classNames: '',
        displayType: 'text',
        inputType: 'option',
        searchable: true,
        editable: true,
        isMulti: true,
        options: GpCddProcessOptions,
        color: '',
        group: 3,
    },
    {
        key: 'us_qualify_cdd',
        label: 'Us qualify Cdd (DVTJCUV)',
        classNames: '',
        displayType: 'text',
        inputType: 'option',
        searchable: true,
        editable: true,
        isMulti: true,
        options: UsQualifyCddOptions,
        group: 3,
    },
    {
        key: 'to_do_w_cdd',
        label: 'To do w Cdd (DVTJCUV)',
        classNames: '',
        displayType: 'text',
        inputType: 'option',
        searchable: true,
        editable: true,
        isMulti: true,
        options: TodoWCddOptions,
        color: '',
        group: 3,
    },
    {
        key: 'current_fu_strategy_date_time',
        label: 'FU Strategy (This time)',
        classNames: '',
        displayType: 'text',
        inputType: 'text',
        inputRange: false,
        editable: true,
        autoAdd: false,
        capitalize: false,
        searchable: true,
        group: 4,
    },
    {
        key: 'current_fu_campaign',
        label: 'FU Compaign (This time)',
        classNames: '',
        displayType: 'text',
        inputType: 'text',
        editable: true,
        autoAdd: false,
        capitalize: false,
        searchable: true,
        group: 4,
    },
    {
        key: 'next_fu_schedule_date_time',
        label: 'FU Schedule (Next time)',
        classNames: '',
        displayType: 'text',
        inputType: 'date',
        inputRange: true,
        editable: true,
        autoAdd: false,
        capitalize: false,
        searchable: true,
        group: 5,
    },
    {
        key: 'next_fu_strategy_date_time',
        label: 'FU Strategy (Next time)',
        classNames: '',
        displayType: 'text',
        inputType: 'text',
        inputRange: false,
        editable: true,
        autoAdd: false,
        capitalize: false,
        searchable: true,
        group: 5,
    },
    {
        key: 'next_fu_campaign',
        label: 'FU Compaign (Next time)',
        classNames: '',
        displayType: 'text',
        inputType: 'text',
        editable: true,
        autoAdd: false,
        capitalize: false,
        searchable: true,
        group: 5,
    },
    {
        key: 'cdd_receiver_id',
        label: 'Cdd Receiver ID',
        classNames: '',
        displayType: 'link',
        inputType: 'number',
        editable: true,
        link: '/candidate/detail/',
        searchable: true,
        group: 6,
    },
    {
        key: 'cdd_receiver_full_name',
        label: 'Họ và tên',
        classNames: '',
        displayType: 'text',
        inputType: 'text',
        editable: false,
        autoAdd: true,
        capitalize: true,
        searchable: false,
        group: 6,
    },
    {
        key: 'cdd_receiver_displayed_company',
        label: 'Displayed Company',
        classNames: '',
        displayType: 'text',
        inputType: 'text',
        editable: false,
        capitalize: true,
        autoAdd: true,
        searchable: false,
        group: 6,
    },
    {
        key: 'cdd_receiver_displayed_title',
        label: 'Displayed Title',
        classNames: '',
        displayType: 'text',
        inputType: 'text',
        editable: false,
        capitalize: true,
        autoAdd: true,
        searchable: false,
        group: 6,
    },
    {
        key: 'cdd_receiver_local_province_email',
        label: 'Loca tỉnh (email)',
        classNames: '',
        displayType: 'text',
        inputType: 'text',
        editable: false,
        capitalize: true,
        autoAdd: true,
        searchable: false,
        group: 6,
    },
    {
        key: 'cdd_receiver_industry',
        label: 'Industry',
        classNames: '',
        displayType: 'text',
        inputType: 'text',
        editable: false,
        capitalize: true,
        autoAdd: true,
        searchable: false,
        group: 6,
    },
    {
        key: 'cdd_receiver_function',
        label: 'Function',
        classNames: '',
        displayType: 'text',
        inputType: 'text',
        editable: false,
        capitalize: false,
        autoAdd: true,
        searchable: false,
        group: 6,
    },
    {
        key: 'candidate_receive_request',
        label: 'Yêu cầu nhận UV (DVTJCUV)',
        classNames: '',
        displayType: 'text',
        inputType: 'option',
        options: ReceiveRequestOptions,
        isMulti: true,
        editable: false,
        group: 6,
    },
    {
        key: 'cdd_receiver_category',
        label: 'Phân loại as a Cdd Receiver',
        classNames: '',
        displayType: 'text',
        inputType: 'option',
        editable: false,
        options: ReceiverCategoryOptions,
        isMulti: true,
        group: 6,
    },
    {
        key: 'employer_id',
        label: 'Employer',
        classNames: '',
        displayType: 'link',
        inputType: 'number',
        editable: false,
        link: '/employer/edit/',
        searchable: true,
        autoAdd: true,
        group: 6,
    },
    {
        key: 'employer_name',
        label: 'Employer Name',
        classNames: '',
        displayType: 'text',
        inputType: 'text',
        editable: false,
        searchable: false,
        autoAdd: true,
        group: 6,
    },
    {
        key: 'rec_upd_info_mail_send_times',
        label: 'Lần gửi email đn Rec update info',
        classNames: '',
        displayType: 'text',
        inputType: 'number',
        editable: true,
        searchable: false,
        group: 7,
    },
    {
        key: 'rec_upd_info_fu_schedule',
        label: 'FU Schedule (Rec update info)',
        classNames: '',
        displayType: 'text',
        inputType: 'date',
        inputRange: true,
        editable: true,
        searchable: false,
        group: 7,
    },
    {
        key: 'cdd_receiver_me_check_status',
        label: 'Trạng thái check ME của Cdd Receiver',
        classNames: '',
        displayType: 'text',
        inputType: 'option',
        searchable: true,
        editable: true,
        isMulti: false,
        options: CddMeCheckStatusOptions,
        color: '',
        group: 7,
    },
    {
        key: 'gp_emp_process',
        label: 'GP-Emp Process (Nhận UV)',
        classNames: '',
        displayType: 'text',
        inputType: 'option',
        searchable: true,
        editable: true,
        isMulti: false,
        options: GpEmpProcessOptions,
        color: '',
        group: 7,
    },
    {
        key: 'invite_send_job_gp_emp_process',
        label: 'GP-Emp Process (mời gửi job)',
        classNames: '',
        displayType: 'text',
        inputType: 'option',
        searchable: true,
        editable: true,
        isMulti: false,
        options: InviteSendJobGpEmpProcessOptions,
        color: '',
        group: 8,
    },
    {
        key: 'invite_send_job_todo_w_rec',
        label: 'To do with Rec (mời gửi job)',
        classNames: '',
        displayType: 'text',
        inputType: 'option',
        searchable: true,
        editable: true,
        isMulti: false,
        options: InviteSendJobTodoWRecOptions,
        color: '',
        group: 8,
    },
    {
        key: 'rec_current_fu_strategy_date_time',
        label: '(REC) FU Strategy (This time)',
        classNames: '',
        displayType: 'text',
        inputType: 'text',
        inputRange: false,
        editable: true,
        autoAdd: false,
        capitalize: false,
        searchable: true,
        group: 8,
    },
    {
        key: 'rec_current_fu_campaign',
        label: '(REC) FU Compaign (This time)',
        classNames: '',
        displayType: 'text',
        inputType: 'text',
        editable: true,
        autoAdd: false,
        capitalize: false,
        searchable: true,
        group: 8,
    },
    {
        key: 'rec_next_fu_schedule_date_time',
        label: '(REC) FU Schedule (Next time)',
        classNames: '',
        displayType: 'text',
        inputType: 'date',
        inputRange: true,
        editable: true,
        autoAdd: false,
        capitalize: false,
        searchable: true,
        group: 8,
    },
    {
        key: 'rec_next_fu_strategy_date_time',
        label: '(REC) FU Strategy (Next time)',
        classNames: '',
        displayType: 'text',
        inputType: 'text',
        inputRange: false,
        editable: true,
        autoAdd: false,
        capitalize: false,
        searchable: true,
        group: 8,
    },
    {
        key: 'rec_next_fu_campaign',
        label: '(REC) FU Compaign (Next time)',
        classNames: '',
        displayType: 'text',
        inputType: 'text',
        editable: true,
        autoAdd: false,
        capitalize: false,
        searchable: true,
        group: 8,
    },
    {
        key: 'matching_potential',
        label: 'Tiềm năng Matching',
        classNames: '',
        displayType: 'text',
        inputType: 'option',
        searchable: true,
        editable: true,
        isMulti: false,
        options: MatchingPotentialOptions,
        color: '',
        group: 7,
    },
    {
        key: 'receiver_comment_cdd',
        label: 'Receiver nhận xét Cdd',
        classNames: '',
        displayType: 'text',
        inputType: 'option',
        editable: true,
        isMulti: true,
        autoAdd: false,
        capitalize: false,
        searchable: false,
        options: ReceiverCommentCddOptions,
        group: 7,
    },
    {
        key: 'cdd_emp_process',
        label: 'Cdd-Emp Process',
        classNames: '',
        displayType: 'text',
        inputType: 'option',
        searchable: true,
        editable: true,
        isMulti: false,
        options: CddEmpProcessOptions,
        color: '',
        group: 7,
    },
    {
        key: 'job_id',
        label: 'Job',
        classNames: '',
        displayType: 'link',
        inputType: 'number',
        editable: true,
        link: '/job/edit/',
        searchable: true,
        group: 7,
    },
    {
        key: 'job_name',
        label: 'Job Name',
        classNames: '',
        displayType: 'text',
        inputType: 'text',
        editable: false,
        searchable: false,
        autoAdd: true,
        group: 7,
    },
    {
        key: 'cdd_emp_fu_needed',
        label: 'FU needed(Cdd-Emp)',
        classNames: '',
        displayType: 'text',
        inputType: 'option',
        searchable: true,
        editable: true,
        isMulti: true,
        options: CddEmpFuNeededOptions,
        color: '',
        group: 9,
    },
    {
        key: 'cdd_emp_fu_schedule',
        label: 'FU Schedule (Cdd-Emp)',
        classNames: '',
        displayType: 'text',
        inputType: 'date',
        inputRange: true,
        editable: true,
        autoAdd: false,
        capitalize: false,
        searchable: true,
        group: 9,
    },
    {
        key: 'note_discussion_w_cdd',
        label: 'Note Discussion w Cdd',
        classNames: '',
        displayType: 'text',
        inputType: 'textarea',
        editable: true,
        autoAdd: false,
        capitalize: false,
        searchable: true,
        group: 10,
    },
    // {key: 'note_discussion_w_employer', label: 'Note Discussion w Employer', classNames: '', displayType: 'text', inputType: 'text', editable: true, autoAdd: false, capitalize: false, searchable: true},
    {
        key: 'note_discussion_w_receiver',
        label: 'Note Discussion w Receiver',
        classNames: '',
        displayType: 'text',
        inputType: 'textarea',
        editable: true,
        autoAdd: false,
        capitalize: false,
        searchable: true,
        group: 10,
    },
    {
        key: 'fee_to_employer',
        label: 'Fee to Employer',
        classNames: '',
        displayType: 'text',
        inputType: 'number',
        editable: true,
        autoAdd: false,
        capitalize: false,
        searchable: true,
        group: 11,
    },
    {
        key: 'payment_and_warranty',
        label: 'Thanh toán & Bảo hành',
        classNames: '',
        displayType: 'text',
        inputType: 'option',
        searchable: true,
        editable: true,
        isMulti: false,
        options: PaymentAndWarrantyOptions,
        group: 11,
    },
    {
        key: 'gd_tt_bh_fu_needed',
        label: 'FU needed (GĐ TT-BH)',
        classNames: '',
        displayType: 'text',
        inputType: 'option',
        searchable: true,
        editable: true,
        isMulti: true,
        options: GdTTBHFuNeededOptions,
        color: '',
        group: 11,
    },
    {
        key: 'notes',
        label: 'Notes',
        classNames: '',
        displayType: 'text',
        inputType: 'textarea',
        searchable: true,
        editable: true,
        group: 12,
    },
    {
        key: 'note_with_cdd',
        label: 'Note with Cdd',
        classNames: '',
        displayType: 'text',
        inputType: 'text',
        searchable: true,
        editable: true,
        group: 12,
    },
    {
        key: 'process_priority',
        label: 'Ưu tiên xử lý',
        classNames: '',
        displayType: 'text',
        inputType: 'option',
        options: ProcessPriorityOptions,
        editable: true,
        group: 12,
    },
];

export const DVTJCUVPipelineTableZColumns = [
    // {
    //     key: 'id',
    //     label: 'Pipeline ID',
    //     classNames: '',
    //     displayType: 'text',
    //     inputType: 'number',
    //     editable: false,
    //     autoAdd: true,
    //     searchable: true
    // },
    // {
    //     key: 'created_date_time',
    //     label: 'Note time',
    //     classNames: '',
    //     displayType: 'text',
    //     inputType: 'date',
    //     editable: false,
    //     autoAdd: true,
    //     searchable: false
    // },
    {
        key: 'cdd_receiver_id',
        label: 'Cdd Receiver ID',
        classNames: '',
        displayType: 'link',
        inputType: 'number',
        editable: true,
        link: '/candidate/detail/',
        searchable: true
    },
    {
        key: 'cdd_receiver_full_name',
        label: 'Họ và tên',
        classNames: '',
        displayType: 'text',
        inputType: 'text',
        editable: false,
        autoAdd: true,
        capitalize: true,
        searchable: true
    },
    {
        key: 'cdd_receiver_displayed_company',
        label: 'Displayed Company',
        classNames: '',
        displayType: 'text',
        inputType: 'text',
        editable: false,
        capitalize: true,
        autoAdd: true,
        searchable: false
    },
    {
        key: 'cdd_receiver_displayed_title',
        label: 'Displayed Title',
        classNames: '',
        displayType: 'text',
        inputType: 'text',
        editable: false,
        capitalize: true,
        autoAdd: true,
        searchable: false
    },
    {
        key: 'local_province_email',
        label: 'Loca tỉnh (email)',
        classNames: '',
        displayType: 'text',
        inputType: 'text',
        editable: false,
        capitalize: true,
        autoAdd: true,
        searchable: false
    },
    {
        key: 'industry',
        label: 'Industry',
        classNames: '',
        displayType: 'text',
        inputType: 'text',
        editable: false,
        capitalize: true,
        autoAdd: true,
        searchable: false
    },
    {
        key: 'function',
        label: 'Function',
        classNames: '',
        displayType: 'text',
        inputType: 'text',
        editable: false,
        capitalize: false,
        autoAdd: true,
        searchable: true
    },
];


export const DVTJCUVPipelineTableWColumns = [
    {
        key: 'id',
        label: 'Pipeline ID',
        classNames: '',
        displayType: 'text',
        inputType: 'number',
        editable: false,
        autoAdd: true,
        searchable: true
    },
    {
        key: 'cdd_id',
        label: 'Cdd ID',
        classNames: '',
        displayType: 'link',
        inputType: 'number',
        editable: true,
        link: '/candidate/detail/',
        searchable: true
    },
    {
        key: 'cdd_full_name',
        label: 'Họ và tên',
        classNames: '',
        displayType: 'text',
        inputType: 'text',
        editable: false,
        autoAdd: true,
        capitalize: true,
        searchable: true
    },
    {
        key: 'cdd_displayed_company',
        label: 'Displayed Company',
        classNames: '',
        displayType: 'text',
        inputType: 'text',
        editable: false,
        capitalize: true,
        autoAdd: true,
        searchable: false
    },
    {
        key: 'cdd_displayed_title',
        label: 'Displayed Title',
        classNames: '',
        displayType: 'text',
        inputType: 'text',
        editable: false,
        capitalize: true,
        autoAdd: true,
        searchable: false
    },
    {
        key: 'cdd_local_province_email',
        label: 'Loca tỉnh (email)',
        classNames: '',
        displayType: 'text',
        inputType: 'text',
        editable: false,
        capitalize: true,
        autoAdd: true,
        searchable: false
    },
    {
        key: 'cdd_industry',
        label: 'Industry',
        classNames: '',
        displayType: 'text',
        inputType: 'text',
        editable: false,
        capitalize: true,
        autoAdd: true,
        searchable: false
    },
    {
        key: 'cdd_function',
        label: 'Function',
        classNames: '',
        displayType: 'text',
        inputType: 'text',
        editable: false,
        capitalize: false,
        autoAdd: true,
        searchable: true
    },
    {
        key: 'cdd_receiver_id',
        label: 'Cdd Receiver ID',
        classNames: '',
        displayType: 'link',
        inputType: 'number',
        editable: true,
        link: '/candidate/detail/',
        searchable: true
    },
    {
        key: 'cdd_receiver_full_name',
        label: 'Họ và tên',
        classNames: '',
        displayType: 'text',
        inputType: 'text',
        editable: false,
        autoAdd: true,
        capitalize: true,
        searchable: true
    },
    {
        key: 'cdd_receiver_displayed_company',
        label: 'Displayed Company',
        classNames: '',
        displayType: 'text',
        inputType: 'text',
        editable: false,
        capitalize: true,
        autoAdd: true,
        searchable: false
    },
    {
        key: 'cdd_receiver_displayed_title',
        label: 'Displayed Title',
        classNames: '',
        displayType: 'text',
        inputType: 'text',
        editable: false,
        capitalize: true,
        autoAdd: true,
        searchable: false
    },
    {
        key: 'employer_name',
        label: 'Employer Name',
        classNames: '',
        displayType: 'text',
        inputType: 'text',
        autoAdd: true,
        editable: false,
        searchable: false
    },
    {
        key: 'job_id',
        label: 'Job',
        classNames: '',
        displayType: 'link',
        inputType: 'number',
        editable: true,
        link: '/job/edit/',
        searchable: true
    },
    {
        key: 'gp_emp_process',
        label: 'GP-Emp Process (Nhận UV)',
        classNames: '',
        displayType: 'text',
        inputType: 'option',
        searchable: true,
        editable: true,
        isMulti: false,
        options: GpEmpProcessOptions,
        color: ''
    },
    {
        key: 'cdd_emp_process',
        label: 'Cdd-Emp Process',
        classNames: '',
        displayType: 'text',
        inputType: 'option',
        searchable: true,
        editable: true,
        isMulti: false,
        options: CddEmpProcessOptions,
        color: ''
    },
    {
        key: 'cdd_emp_fu_needed',
        label: 'FU needed (Cdd-Emp)',
        classNames: '',
        displayType: 'text',
        inputType: 'option',
        searchable: true,
        editable: true,
        isMulti: true,
        options: CddEmpFuNeededOptions,
        color: ''
    },
    {
        key: 'cdd_emp_fu_schedule',
        label: 'FU Schedule (Cdd-Emp)',
        classNames: '',
        displayType: 'text',
        inputType: 'date',
        inputRange: true,
        editable: true,
        autoAdd: false,
        capitalize: false,
        searchable: true
    },
    {
        key: 'payment_and_warranty',
        label: 'Thanh toán & Bảo hành',
        classNames: '',
        displayType: 'text',
        inputType: 'option',
        searchable: true,
        editable: true,
        isMulti: false,
        options: PaymentAndWarrantyOptions
    },
    {
        key: 'gd_tt_bh_fu_needed',
        label: 'FU needed (GĐ TT-BH)',
        classNames: '',
        displayType: 'text',
        inputType: 'option',
        searchable: true,
        editable: true,
        isMulti: true,
        options: GdTTBHFuNeededOptions,
        color: ''
    },
    {
        key: 'notes',
        label: 'Notes',
        classNames: '',
        displayType: 'text',
        inputType: 'textarea',
        searchable: true,
        editable: true
    },
];

export const DVTJCUVPipelineTablePColumns = [
    {
        key: 'id',
        label: 'Pipeline ID',
        classNames: '',
        displayType: 'text',
        inputType: 'number',
        editable: false,
        autoAdd: true,
        searchable: true
    },
    {
        key: 'cdd_id',
        label: 'Cdd ID',
        classNames: '',
        displayType: 'link',
        inputType: 'number',
        editable: true,
        link: '/candidate/detail/',
        searchable: true
    },
    {
        key: 'cdd_full_name',
        label: 'Họ và tên',
        classNames: '',
        displayType: 'text',
        inputType: 'text',
        editable: false,
        autoAdd: true,
        capitalize: true,
        searchable: true
    },
    {
        key: 'cdd_displayed_company',
        label: 'Displayed Company',
        classNames: '',
        displayType: 'text',
        inputType: 'text',
        editable: false,
        capitalize: true,
        autoAdd: true,
        searchable: false
    },
    {
        key: 'cdd_displayed_title',
        label: 'Displayed Title',
        classNames: '',
        displayType: 'text',
        inputType: 'text',
        editable: false,
        capitalize: true,
        autoAdd: true,
        searchable: false
    },
    {
        key: 'cdd_local_province_email',
        label: 'Loca tỉnh (email)',
        classNames: '',
        displayType: 'text',
        inputType: 'text',
        editable: false,
        capitalize: true,
        autoAdd: true,
        searchable: false
    },
    {
        key: 'cdd_industry',
        label: 'Industry',
        classNames: '',
        displayType: 'text',
        inputType: 'text',
        editable: false,
        capitalize: true,
        autoAdd: true,
        searchable: false
    },
    {
        key: 'cdd_function',
        label: 'Function',
        classNames: '',
        displayType: 'text',
        inputType: 'text',
        editable: false,
        capitalize: false,
        autoAdd: true,
        searchable: true
    },
    {
        key: 'employer_name',
        label: 'Employer Name',
        classNames: '',
        displayType: 'text',
        inputType: 'text',
        editable: false,
        searchable: false
    },
    {
        key: 'job_id',
        label: 'Job',
        classNames: '',
        displayType: 'link',
        inputType: 'number',
        editable: true,
        link: '/job/edit/',
        searchable: true
    },
    {
        key: 'cdd_emp_process',
        label: 'Cdd-Emp Process',
        classNames: '',
        displayType: 'text',
        inputType: 'option',
        searchable: true,
        editable: true,
        isMulti: false,
        options: CddEmpProcessOptions,
        color: ''
    },
    {
        key: 'payment_and_warranty',
        label: 'Thanh toán & Bảo hành',
        classNames: '',
        displayType: 'text',
        inputType: 'option',
        searchable: true,
        editable: true,
        isMulti: false,
        options: PaymentAndWarrantyOptions
    },
    {
        key: 'gd_tt_bh_fu_needed',
        label: 'FU needed (GĐ TT-BH)',
        classNames: '',
        displayType: 'text',
        inputType: 'option',
        searchable: true,
        editable: true,
        isMulti: true,
        options: GdTTBHFuNeededOptions,
        color: ''
    },
];

export const DVTJCUVPipelineCddConnectEmpBriefSentTableColumns = [
    // {
    //     key: 'id',
    //     label: 'Pipeline ID',
    //     classNames: '',
    //     displayType: 'text',
    //     inputType: 'number',
    //     editable: false,
    //     autoAdd: true,
    //     searchable: true
    // },
    {
        key: 'created_date_time',
        label: 'Note time',
        classNames: '',
        displayType: 'text',
        inputType: 'date',
        editable: false,
        autoAdd: true,
        searchable: false
    },
    {
        key: 'cdd_id',
        label: 'Cdd ID',
        classNames: '',
        displayType: 'link',
        inputType: 'number',
        editable: true,
        link: '/candidate/detail/',
        searchable: true
    },
    {
        key: 'cdd_full_name',
        label: 'Họ và tên',
        classNames: '',
        displayType: 'text',
        inputType: 'text',
        editable: false,
        autoAdd: true,
        capitalize: true,
        searchable: true
    },
    {
        key: 'cdd_displayed_company',
        label: 'Displayed Company',
        classNames: '',
        displayType: 'text',
        inputType: 'text',
        editable: false,
        capitalize: true,
        autoAdd: true,
        searchable: false
    },
    {
        key: 'cdd_displayed_title',
        label: 'Displayed Title',
        classNames: '',
        displayType: 'text',
        inputType: 'text',
        editable: false,
        capitalize: true,
        autoAdd: true,
        searchable: false
    },
    {
        key: 'cdd_local_province_email',
        label: 'Loca tỉnh (email)',
        classNames: '',
        displayType: 'text',
        inputType: 'text',
        editable: false,
        capitalize: true,
        autoAdd: true,
        searchable: false
    },
    {
        key: 'cdd_industry',
        label: 'Industry',
        classNames: '',
        displayType: 'text',
        inputType: 'text',
        editable: false,
        capitalize: true,
        autoAdd: true,
        searchable: false
    },
    {
        key: 'cdd_function',
        label: 'Function',
        classNames: '',
        displayType: 'text',
        inputType: 'text',
        editable: false,
        capitalize: false,
        autoAdd: true,
        searchable: true
    },
    {
        key: 'max_step',
        label: 'Step cao nhất',
        classNames: '',
        displayType: 'text',
        inputType: 'text',
        editable: false,
        capitalize: false,
        autoAdd: false,
        searchable: true
    },
    {
        key: 'receiver_sent_count',
        label: 'Số Receiver Sent',
        classNames: '',
        displayType: 'text',
        inputType: 'text',
        editable: false,
        capitalize: false,
        autoAdd: false,
        searchable: true
    },
    {
        key: 'employer_sent_count',
        label: 'Số Employer Sent',
        classNames: '',
        displayType: 'text',
        inputType: 'text',
        editable: false,
        capitalize: false,
        autoAdd: false,
        searchable: true
    },
    {
        key: 'offer_count',
        label: 'Offer',
        classNames: '',
        displayType: 'text',
        inputType: 'option',
        searchable: true,
        editable: true,
        isMulti: false,
        options: CddEmpProcessOptions,
        color: ''
    },
    {
        key: 'itv_count',
        label: 'ITV',
        classNames: '',
        displayType: 'text',
        inputType: 'option',
        searchable: true,
        editable: true,
        isMulti: false,
        options: CddEmpProcessOptions,
        color: ''
    },
    {
        key: 'job_count',
        label: 'Job',
        classNames: '',
        displayType: 'text',
        inputType: 'number',
        editable: true,
        searchable: true
    },
    {
        key: 'cv_sent_count',
        label: 'CV sent',
        classNames: '',
        displayType: 'text',
        inputType: 'number',
        editable: true,
        searchable: true
    },
    {
        key: 'brief_sent_count',
        label: 'Brief sent',
        classNames: '',
        displayType: 'text',
        inputType: 'number',
        editable: true,
        searchable: true
    },
];


export const SearchPipelineFields = [
    {
        key: 'id',
        label: 'Pipeline ID',
        classNames: '',
        displayType: 'text',
        inputType: 'number',
        editable: false,
        autoAdd: true,
        searchable: true,
        group: 1
    },
    {
        key: 'cdd_id',
        label: 'Cdd ID',
        classNames: '',
        displayType: 'link',
        inputType: 'number',
        editable: true,
        link: '/candidate/detail/',
        searchable: true,
        group: 2,
    },
    {
        key: 'dvtjcuv_client_id',
        label: 'Cdd ID (DVTJCUV)',
        classNames: '',
        displayType: 'text',
        inputType: 'number',
        editable: false,
        autoAdd: true,
        searchable: true,
        group: 2,
    },
    {
        key: 'service_use_times',
        label: 'Lần SD dịch vụ',
        classNames: '',
        displayType: 'text',
        inputType: 'number',
        editable: false,
        capitalize: false,
        autoAdd: true,
        searchable: true,
        group: 3,
    },
    {
        key: 'cdd_me_check_status',
        label: 'Trạng thái check ME của Cdd',
        classNames: '',
        displayType: 'text',
        inputType: 'option',
        searchable: true,
        editable: true,
        isMulti: false,
        options: CddMeCheckStatusOptions,
        color: '',
        group: 3,
    },
    {
        key: 'interactive_channel',
        label: 'Loại tương tác',
        classNames: '',
        displayType: 'text',
        inputType: 'option',
        searchable: true,
        editable: true,
        isMulti: false,
        options: InteractiveChannelOptions,
        color: '',
        group: 3,
    },
    {
        key: 'gp_cdd_process',
        label: 'GP-Cdd Process (DVTJCUV)',
        classNames: '',
        displayType: 'text',
        inputType: 'option',
        searchable: true,
        editable: true,
        isMulti: true,
        options: GpCddProcessOptions,
        color: '',
        group: 3,
    },
    {
        key: 'us_qualify_cdd',
        label: 'Us qualify Cdd (DVTJCUV)',
        classNames: '',
        displayType: 'text',
        inputType: 'option',
        searchable: true,
        editable: true,
        isMulti: true,
        options: UsQualifyCddOptions,
        group: 3,
    },
    {
        key: 'to_do_w_cdd',
        label: 'To do w Cdd (DVTJCUV)',
        classNames: '',
        displayType: 'text',
        inputType: 'option',
        searchable: true,
        editable: true,
        isMulti: true,
        options: TodoWCddOptions,
        color: '',
        group: 3,
    },
    {
        key: 'current_fu_strategy_date_time',
        label: 'FU Strategy (This time)',
        classNames: '',
        displayType: 'text',
        inputType: 'text',
        editable: true,
        autoAdd: false,
        capitalize: false,
        searchable: true,
        group: 4,
    },
    {
        key: 'current_fu_campaign',
        label: 'FU Compaign (This time)',
        classNames: '',
        displayType: 'text',
        inputType: 'text',
        editable: true,
        autoAdd: false,
        capitalize: false,
        searchable: true,
        group: 4,
    },
    {
        key: 'rec_current_fu_strategy_date_time',
        label: '(REC) FU Strategy (This time)',
        classNames: '',
        displayType: 'text',
        inputType: 'text',
        inputRange: false,
        editable: true,
        autoAdd: false,
        capitalize: false,
        searchable: true,
        group: 4,
    },
    {
        key: 'rec_current_fu_campaign',
        label: '(REC) FU Compaign (This time)',
        classNames: '',
        displayType: 'text',
        inputType: 'text',
        editable: true,
        autoAdd: false,
        capitalize: false,
        searchable: true,
        group: 4,
    },
    {
        key: 'next_fu_schedule_date_time',
        label: 'FU Schedule (Next time)',
        classNames: '',
        displayType: 'text',
        inputType: 'date',
        editable: true,
        autoAdd: false,
        capitalize: false,
        searchable: true,
        group: 5,
    },
    {
        key: 'next_fu_strategy_date_time',
        label: 'FU Strategy (Next time)',
        classNames: '',
        displayType: 'text',
        inputType: 'text',
        editable: true,
        autoAdd: false,
        capitalize: false,
        searchable: true,
        group: 5,
    },
    {
        key: 'next_fu_campaign',
        label: 'FU Compaign (Next time)',
        classNames: '',
        displayType: 'text',
        inputType: 'text',
        editable: true,
        autoAdd: false,
        capitalize: false,
        searchable: true,
        group: 5,
    },
    {
        key: 'rec_next_fu_schedule_date_time',
        label: '(REC) FU Schedule (Next time)',
        classNames: '',
        displayType: 'text',
        inputType: 'date',
        inputRange: true,
        editable: true,
        autoAdd: false,
        capitalize: false,
        searchable: true,
        group: 5,
    },
    {
        key: 'rec_next_fu_strategy_date_time',
        label: '(REC) FU Strategy (Next time)',
        classNames: '',
        displayType: 'text',
        inputType: 'text',
        inputRange: false,
        editable: true,
        autoAdd: false,
        capitalize: false,
        searchable: true,
        group: 5,
    },
    {
        key: 'rec_next_fu_campaign',
        label: '(REC) FU Compaign (Next time)',
        classNames: '',
        displayType: 'text',
        inputType: 'text',
        editable: true,
        autoAdd: false,
        capitalize: false,
        searchable: true,
        group: 5,
    },
    {
        key: 'cdd_receiver_id',
        label: 'Cdd Receiver ID',
        classNames: '',
        displayType: 'link',
        inputType: 'number',
        editable: true,
        link: '/candidate/detail/',
        searchable: true,
        group: 6,
    },
    {
        key: 'cdd_receiver_me_check_status',
        label: 'Trạng thái check ME của Cdd Receiver',
        classNames: '',
        displayType: 'text',
        inputType: 'option',
        searchable: true,
        editable: true,
        isMulti: false,
        options: CddMeCheckStatusOptions,
        color: '',
        group: 7,
    },
    {
        key: 'gp_emp_process',
        label: 'GP-Emp Process (Nhận UV)',
        classNames: '',
        displayType: 'text',
        inputType: 'option',
        searchable: true,
        editable: true,
        isMulti: false,
        options: GpEmpProcessOptions,
        color: '',
        group: 7,
    },
    {
        key: 'invite_send_job_gp_emp_process',
        label: 'GP-Emp Process (mời gửi job)',
        classNames: '',
        displayType: 'text',
        inputType: 'option',
        searchable: true,
        editable: true,
        isMulti: false,
        options: InviteSendJobGpEmpProcessOptions,
        color: '',
        group: 7,
    },
    {
        key: 'invite_send_job_todo_w_rec',
        label: 'To do with Rec (mời gửi job)',
        classNames: '',
        displayType: 'text',
        inputType: 'option',
        searchable: true,
        editable: true,
        isMulti: false,
        options: InviteSendJobTodoWRecOptions,
        color: '',
        group: 7,
    },
    {
        key: 'employer_id',
        label: 'Employer',
        classNames: '',
        displayType: 'link',
        inputType: 'number',
        editable: true,
        link: '/employer/edit/',
        searchable: true,
        group: 6,
    },
    {
        key: 'employer_name',
        label: 'Employer Name',
        classNames: '',
        displayType: 'text',
        inputType: 'text',
        editable: false,
        searchable: true,
        autoAdd: true,
        group: 6,
    },
    {
        key: 'matching_potential',
        label: 'Tiềm năng Matching',
        classNames: '',
        displayType: 'text',
        inputType: 'option',
        searchable: true,
        editable: true,
        isMulti: false,
        options: MatchingPotentialOptions,
        color: '',
        group: 7,
    },
    {
        key: 'receiver_comment_cdd',
        label: 'Receiver nhận xét Cdd',
        classNames: '',
        displayType: 'text',
        inputType: 'option',
        editable: true,
        isMulti: true,
        autoAdd: false,
        capitalize: false,
        searchable: true,
        options: ReceiverCommentCddOptions,
        group: 7,
    },
    {
        key: 'cdd_emp_process',
        label: 'Cdd-Emp Process',
        classNames: '',
        displayType: 'text',
        inputType: 'option',
        searchable: true,
        editable: true,
        isMulti: false,
        options: CddEmpProcessOptions,
        color: '',
        group: 7,
    },
    {
        key: 'job_id',
        label: 'Job ID',
        classNames: '',
        displayType: 'link',
        inputType: 'number',
        editable: true,
        link: '/job/edit/',
        searchable: true,
        group: 7,
    },
    {
        key: 'job_name',
        label: 'Job Name',
        classNames: '',
        displayType: 'text',
        inputType: 'text',
        editable: false,
        searchable: true,
        group: 7,
    },
    {
        key: 'cdd_emp_fu_needed',
        label: 'FU needed(Cdd-Emp)',
        classNames: '',
        displayType: 'text',
        inputType: 'option',
        searchable: true,
        editable: true,
        isMulti: true,
        options: CddEmpFuNeededOptions,
        color: '',
        group: 8,
    },
    {
        key: 'cdd_emp_fu_schedule',
        label: 'FU Schedule (Cdd-Emp)',
        classNames: '',
        displayType: 'text',
        inputType: 'date',
        inputRange: true,
        editable: true,
        autoAdd: false,
        capitalize: false,
        searchable: true,
        group: 8,
    },
    {
        key: 'note_discussion_w_cdd',
        label: 'Note Discussion w Cdd',
        classNames: '',
        displayType: 'text',
        inputType: 'textarea',
        editable: true,
        autoAdd: false,
        capitalize: false,
        searchable: true,
        group: 9,
    },
    // {key: 'note_discussion_w_employer', label: 'Note Discussion w Employer', classNames: '', displayType: 'text', inputType: 'text', editable: true, autoAdd: false, capitalize: false, searchable: true},
    {
        key: 'note_discussion_w_receiver',
        label: 'Note Discussion w Receiver',
        classNames: '',
        displayType: 'text',
        inputType: 'textarea',
        editable: true,
        autoAdd: false,
        capitalize: false,
        searchable: true,
        group: 9,
    },
    {
        key: 'fee_to_employer',
        label: 'Fee to Employer',
        classNames: '',
        displayType: 'text',
        inputType: 'number',
        editable: true,
        autoAdd: false,
        capitalize: false,
        searchable: true,
        group: 10,
    },
    {
        key: 'payment_and_warranty',
        label: 'Thanh toán & Bảo hành',
        classNames: '',
        displayType: 'text',
        inputType: 'option',
        searchable: true,
        editable: true,
        isMulti: false,
        options: PaymentAndWarrantyOptions,
        group: 10,
    },
    {
        key: 'gd_tt_bh_fu_needed',
        label: 'FU needed (GĐ TT-BH)',
        classNames: '',
        displayType: 'text',
        inputType: 'option',
        searchable: true,
        editable: true,
        isMulti: true,
        options: GdTTBHFuNeededOptions,
        color: '',
        group: 10,
    },
    {
        key: 'notes',
        label: 'Notes',
        classNames: '',
        displayType: 'text',
        inputType: 'textarea',
        searchable: true,
        editable: true,
        group: 11,
    },
    {
        key: 'note_with_cdd',
        label: 'Note with Cdd',
        classNames: '',
        displayType: 'text',
        inputType: 'textarea',
        searchable: true,
        editable: true,
        group: 11,
    },
    {
        key: 'process_priority',
        label: 'Ưu tiên xử lý',
        classNames: '',
        displayType: 'text',
        inputType: 'option',
        options: ProcessPriorityOptions,
        searchable: true,
        editable: true,
        group: 11,
    },

];

export const DVTJCUVPipelineSearchCddTableColumns = [
    {
        key: 'cdd_id',
        label: 'Cdd ID',
        classNames: '',
        displayType: 'link',
        inputType: 'number',
        editable: true,
        link: '/candidate/detail/',
        searchable: true
    },
    {
        key: 'cdd_full_name',
        label: 'Họ và tên',
        classNames: '',
        displayType: 'text',
        inputType: 'text',
        editable: false,
        autoAdd: true,
        capitalize: true,
        searchable: true
    },
    {
        key: 'cdd_displayed_company',
        label: 'Displayed Company',
        classNames: '',
        displayType: 'text',
        inputType: 'text',
        editable: false,
        capitalize: true,
        autoAdd: true,
        searchable: false
    },
    {
        key: 'cdd_displayed_title',
        label: 'Displayed Title',
        classNames: '',
        displayType: 'text',
        inputType: 'text',
        editable: false,
        capitalize: true,
        autoAdd: true,
        searchable: false
    },
    {
        key: 'cdd_local_province_email',
        label: 'Loca tỉnh (email)',
        classNames: '',
        displayType: 'text',
        inputType: 'text',
        editable: false,
        capitalize: true,
        autoAdd: true,
        searchable: false
    },

    // Todo: bỏ các trường này theo thống nhất trong map TEST Set Bảng DVTJCUV Pipeline - ver 12
    // key: Chưa có giá trị cho cột Tab chứa dòng này
    // {
    //     key: 'current_find_job_mode',
    //     label: 'Chế độ tìm job',
    //     classNames: '',
    //     displayType: 'text',
    //     inputType: 'option',
    //     isMulti: false,
    //     options: JobFindModeOptions,
    //     editable: false,
    //     capitalize: true,
    //     autoAdd: true,
    //     searchable: false
    // },
    // {
    //     key: 'service_use_times',
    //     label: 'Lần SD dịch vụ',
    //     classNames: '',
    //     displayType: 'text',
    //     inputType: 'text',
    //     editable: false,
    //     capitalize: false,
    //     autoAdd: true,
    //     searchable: true
    // },
    // {
    //     key: 'tab',
    //     label: 'Tab chứa dòng này',
    //     classNames: '',
    //     displayType: 'text',
    //     inputType: 'textarea',
    //     searchable: true,
    //     editable: true
    // },
];

export const DVTJCUVPipelineP2TableColumns = [
    {
        key: 'employer_id',
        label: 'Employer',
        classNames: '',
        displayType: 'link',
        inputType: 'number',
        editable: false,
        link: '/employer/edit/',
        searchable: true,
    },
    {
        key: 'employer_name',
        label: 'Employer Name',
        classNames: '',
        displayType: 'text',
        inputType: 'text',
        editable: false,
        searchable: false,
    },
    {
        key: 'cdd_emp_process',
        label: 'Cdd-Emp Process',
        classNames: '',
        displayType: 'text',
        inputType: 'option',
        searchable: true,
        editable: true,
        isMulti: false,
        options: CddEmpProcessOptions,
        color: ''
    },
    {
        key: 'job_id',
        label: 'Job ID',
        classNames: '',
        displayType: 'link',
        inputType: 'number',
        editable: true,
        link: '/job/edit/',
        searchable: true
    },
    {
        key: 'job_name',
        label: 'Job Name',
        classNames: '',
        displayType: 'text',
        inputType: 'text',
        editable: false,
        searchable: false
    },
    {
        key: 'payment_and_warranty',
        label: 'Thanh toán & Bảo hành',
        classNames: '',
        displayType: 'text',
        inputType: 'option',
        searchable: true,
        editable: true,
        isMulti: false,
        options: PaymentAndWarrantyOptions
    },
    {
        key: 'gd_tt_bh_fu_needed',
        label: 'FU needed (GĐ TT-BH)',
        classNames: '',
        displayType: 'text',
        inputType: 'option',
        searchable: true,
        editable: true,
        isMulti: true,
        options: GdTTBHFuNeededOptions,
        color: ''
    },
];

export const DVTJCUVPipelineYTableColumns = [
    // {
    //     key: 'id',
    //     label: 'Pipeline ID',
    //     classNames: '',
    //     displayType: 'text',
    //     inputType: 'number',
    //     editable: false,
    //     autoAdd: true,
    //     searchable: true
    // },
    {
        key: 'cdd_receiver_id',
        label: 'Cdd Receiver ID',
        classNames: '',
        displayType: 'link',
        inputType: 'number',
        editable: true,
        link: '/candidate/detail/',
        searchable: true
    },
    {
        key: 'cdd_receiver_full_name',
        label: 'Họ và tên',
        classNames: '',
        displayType: 'text',
        inputType: 'text',
        editable: false,
        autoAdd: true,
        capitalize: true,
        searchable: true
    },
    {
        key: 'cdd_receiver_displayed_company',
        label: 'Displayed Company',
        classNames: '',
        displayType: 'text',
        inputType: 'text',
        editable: false,
        capitalize: true,
        autoAdd: true,
        searchable: false
    },
    {
        key: 'cdd_receiver_displayed_title',
        label: 'Displayed Title',
        classNames: '',
        displayType: 'text',
        inputType: 'text',
        editable: false,
        capitalize: true,
        autoAdd: true,
        searchable: false
    },
    {
        key: 'employer_name',
        label: 'Employer Name',
        classNames: '',
        displayType: 'text',
        inputType: 'text',
        editable: false,
        searchable: false
    },
    {
        key: 'job_id',
        label: 'Job',
        classNames: '',
        displayType: 'link',
        inputType: 'number',
        editable: true,
        link: '/job/edit/',
        searchable: true
    },
    {
        key: 'job_name',
        label: 'Job Name',
        classNames: '',
        displayType: 'text',
        inputType: 'text',
        editable: false,
        searchable: false
    },
    {
        key: 'gp_emp_process',
        label: 'GP-Emp Process (Nhận UV)',
        classNames: '',
        displayType: 'text',
        inputType: 'option',
        searchable: true,
        editable: true,
        isMulti: false,
        options: GpEmpProcessOptions,
        color: ''
    },
    {
        key: 'cdd_emp_process',
        label: 'Cdd-Emp Process',
        classNames: '',
        displayType: 'text',
        inputType: 'option',
        searchable: true,
        editable: true,
        isMulti: false,
        options: CddEmpProcessOptions,
        color: ''
    },
    {
        key: 'cdd_emp_fu_needed',
        label: 'FU needed(Cdd-Emp)',
        classNames: '',
        displayType: 'text',
        inputType: 'option',
        searchable: true,
        editable: true,
        isMulti: true,
        options: CddEmpFuNeededOptions,
        color: ''
    },
    {
        key: 'cdd_emp_fu_schedule',
        label: 'FU Schedule (Cdd-Emp)',
        classNames: '',
        displayType: 'text',
        inputType: 'date',
        inputRange: true,
        editable: true,
        autoAdd: false,
        capitalize: false,
        searchable: true
    },
    {
        key: 'notes',
        label: 'Notes',
        classNames: '',
        displayType: 'text',
        inputType: 'textarea',
        searchable: true,
        editable: true
    },
];

export const DVTJCUVPipelineProcessedCddTableColumns = [
    {
        key: 'cdd_id',
        label: 'Cdd ID',
        classNames: '',
        displayType: 'link',
        inputType: 'number',
        editable: true,
        link: '/candidate/detail/',
        searchable: true
    },
    {
        key: 'cdd_full_name',
        label: 'Họ và tên',
        classNames: '',
        displayType: 'text',
        inputType: 'text',
        editable: false,
        autoAdd: true,
        capitalize: true,
        searchable: true
    },
    {
        key: 'cdd_displayed_company',
        label: 'Displayed Company',
        classNames: '',
        displayType: 'text',
        inputType: 'text',
        editable: false,
        capitalize: true,
        autoAdd: true,
        searchable: false
    },
    {
        key: 'cdd_displayed_title',
        label: 'Displayed Title',
        classNames: '',
        displayType: 'text',
        inputType: 'text',
        editable: false,
        capitalize: true,
        autoAdd: true,
        searchable: false
    },
    {
        key: 'max_step',
        label: 'Max Step',
        classNames: '',
        displayType: 'text',
        inputType: 'number',
        editable: true,
        searchable: true
    },
];

export const DVTJCUVPipelineXTableColumns = [
    {
        key: 'id',
        label: 'Pipeline ID',
        classNames: '',
        displayType: 'text',
        inputType: 'number',
        editable: false,
        autoAdd: true,
        searchable: true
    },
    {
        key: 'cdd_id',
        label: 'Cdd ID',
        classNames: '',
        displayType: 'link',
        inputType: 'number',
        editable: true,
        link: '/candidate/detail/',
        searchable: true
    },
    {
        key: 'cdd_full_name',
        label: 'Họ và tên',
        classNames: '',
        displayType: 'text',
        inputType: 'text',
        editable: false,
        autoAdd: true,
        capitalize: true,
        searchable: false
    },
    {
        key: 'cdd_displayed_company',
        label: 'Displayed Company',
        classNames: '',
        displayType: 'text',
        inputType: 'text',
        editable: false,
        capitalize: true,
        autoAdd: true,
        searchable: false
    },
    {
        key: 'cdd_displayed_title',
        label: 'Displayed Title',
        classNames: '',
        displayType: 'text',
        inputType: 'text',
        editable: false,
        capitalize: true,
        autoAdd: true,
        searchable: false
    },
    {
        key: 'current_find_job_mode',
        label: 'Chế độ tìm job',
        classNames: '',
        displayType: 'text',
        inputType: 'text',
        editable: false,
        capitalize: true,
        autoAdd: true,
        searchable: false
    },
    {
        key: 'current_find_job_mode_note_time',
        label: 'Note time (Chế độ tìm job)',
        classNames: '',
        displayType: 'text',
        inputType: 'date',
        editable: false,
        capitalize: true,
        autoAdd: true,
        searchable: false
    },
    {
        key: 'cdd_me_check_status',
        label: 'Trạng thái check ME của Cdd',
        classNames: '',
        displayType: 'text',
        inputType: 'option',
        searchable: true,
        editable: true,
        isMulti: false,
        options: CddMeCheckStatusOptions,
        color: ''
    },
    {
        key: 'interactive_channel',
        label: 'Loại tương tác',
        classNames: '',
        displayType: 'text',
        inputType: 'option',
        searchable: true,
        editable: true,
        isMulti: false,
        options: InteractiveChannelOptions,
        color: ''
    },
    {
        key: 'gp_cdd_process',
        label: 'GP-Cdd Process (DVTJCUV)',
        classNames: '',
        displayType: 'text',
        inputType: 'option',
        searchable: true,
        editable: true,
        isMulti: true,
        options: GpCddProcessOptions,
        color: ''
    },
    {
        key: 'to_do_w_cdd',
        label: 'To do w Cdd (DVTJCUV)',
        classNames: '',
        displayType: 'text',
        inputType: 'option',
        searchable: true,
        editable: true,
        isMulti: true,
        options: TodoWCddOptions,
        color: ''
    },
    {
        key: 'current_fu_strategy_date_time',
        label: 'FU Strategy (This time)',
        classNames: '',
        displayType: 'text',
        inputType: 'text',
        inputRange: false,
        editable: true,
        autoAdd: false,
        capitalize: false,
        searchable: true
    },
    {
        key: 'current_fu_campaign',
        label: 'FU Compaign (This time)',
        classNames: '',
        displayType: 'text',
        inputType: 'text',
        editable: true,
        autoAdd: false,
        capitalize: false,
        searchable: true
    },
    {
        key: 'rec_current_fu_strategy_date_time',
        label: '(REC) FU Strategy (This time)',
        classNames: '',
        displayType: 'text',
        inputType: 'text',
        inputRange: false,
        editable: true,
        autoAdd: false,
        capitalize: false,
        searchable: true,
        group: 4,
    },
    {
        key: 'rec_current_fu_campaign',
        label: '(REC) FU Compaign (This time)',
        classNames: '',
        displayType: 'text',
        inputType: 'text',
        editable: true,
        autoAdd: false,
        capitalize: false,
        searchable: true,
        group: 4,
    },
    {
        key: 'next_fu_schedule_date_time',
        label: 'FU Schedule (Next time)',
        classNames: '',
        displayType: 'text',
        inputType: 'date',
        inputRange: true,
        editable: true,
        autoAdd: false,
        capitalize: false,
        searchable: true
    },
    {
        key: 'next_fu_strategy_date_time',
        label: 'FU Strategy (Next time)',
        classNames: '',
        displayType: 'text',
        inputType: 'text',
        inputRange: false,
        editable: true,
        autoAdd: false,
        capitalize: false,
        searchable: true
    },
    {
        key: 'next_fu_campaign',
        label: 'FU Compaign (Next time)',
        classNames: '',
        displayType: 'text',
        inputType: 'text',
        editable: true,
        autoAdd: false,
        capitalize: false,
        searchable: true
    },
    {
        key: 'rec_next_fu_schedule_date_time',
        label: '(REC) FU Schedule (Next time)',
        classNames: '',
        displayType: 'text',
        inputType: 'date',
        inputRange: true,
        editable: true,
        autoAdd: false,
        capitalize: false,
        searchable: true,
        group: 5,
    },
    {
        key: 'rec_next_fu_strategy_date_time',
        label: '(REC) FU Strategy (Next time)',
        classNames: '',
        displayType: 'text',
        inputType: 'text',
        inputRange: false,
        editable: true,
        autoAdd: false,
        capitalize: false,
        searchable: true,
        group: 5,
    },
    {
        key: 'rec_next_fu_campaign',
        label: '(REC) FU Compaign (Next time)',
        classNames: '',
        displayType: 'text',
        inputType: 'text',
        editable: true,
        autoAdd: false,
        capitalize: false,
        searchable: true,
        group: 5,
    },
    {
        key: 'notes',
        label: 'Notes',
        classNames: '',
        displayType: 'text',
        inputType: 'textarea',
        searchable: true,
        editable: true
    },
];

export const DVTJCUVPipelineX2TableColumns = [
    {
        key: 'id',
        label: 'Pipeline ID',
        classNames: '',
        displayType: 'text',
        inputType: 'number',
        editable: false,
        autoAdd: true,
        searchable: true
    },
    {
        key: 'cdd_receiver_id',
        label: 'Cdd Receiver ID',
        classNames: '',
        displayType: 'link',
        inputType: 'number',
        editable: true,
        link: '/candidate/detail/',
        searchable: true
    },
    {
        key: 'cdd_receiver_full_name',
        label: 'Họ và tên',
        classNames: '',
        displayType: 'text',
        inputType: 'text',
        editable: false,
        autoAdd: true,
        capitalize: true,
        searchable: true
    },
    {
        key: 'cdd_receiver_displayed_company',
        label: 'Displayed Company',
        classNames: '',
        displayType: 'text',
        inputType: 'text',
        editable: false,
        capitalize: true,
        autoAdd: true,
        searchable: false
    },
    {
        key: 'cdd_receiver_displayed_title',
        label: 'Displayed Title',
        classNames: '',
        displayType: 'text',
        inputType: 'text',
        editable: false,
        capitalize: true,
        autoAdd: true,
        searchable: false
    },
    // Thêm Employer ID và Employer Name
    {
        key: 'employer_id',
        label: 'Employer ID',
        classNames: '',
        displayType: 'link',
        link: '/employer/edit/',
        inputType: 'number',
        editable: true,
        autoAdd: true,
        searchable: true
    },
    {
        key: 'employer_name',
        label: 'Employer Name',
        classNames: '',
        displayType: 'text',
        inputType: 'text',
        editable: true,
        autoAdd: true,
        searchable: true
    },
    {
        key: 'cdd_receiver_me_check_status',
        label: 'Trạng thái check ME của Cdd Receiver',
        classNames: '',
        displayType: 'text',
        inputType: 'option',
        searchable: true,
        editable: true,
        isMulti: false,
        options: CddMeCheckStatusOptions,
        color: '',
        group: 7,
    },
    {
        key: 'gp_emp_process',
        label: 'GP-Emp Process (Nhận UV)',
        classNames: '',
        displayType: 'text',
        inputType: 'option',
        searchable: true,
        editable: true,
        isMulti: false,
        options: GpEmpProcessOptions,
        color: '',
        group: 7,
    },
    {
        key: 'invite_send_job_gp_emp_process',
        label: 'GP-Emp Process (mời gửi job)',
        classNames: '',
        displayType: 'text',
        inputType: 'option',
        searchable: true,
        editable: true,
        isMulti: false,
        options: InviteSendJobGpEmpProcessOptions,
        color: '',
        group: 7,
    },
    {
        key: 'invite_send_job_todo_w_rec',
        label: 'To do with Rec (mời gửi job)',
        classNames: '',
        displayType: 'text',
        inputType: 'option',
        searchable: true,
        editable: true,
        isMulti: false,
        options: InviteSendJobTodoWRecOptions,
        color: '',
        group: 7,
    },
    {
        key: 'rec_current_fu_strategy_date_time',
        label: '(REC) FU Strategy (This time)',
        classNames: '',
        displayType: 'text',
        inputType: 'text',
        inputRange: false,
        editable: true,
        autoAdd: false,
        capitalize: false,
        searchable: true,
        group: 4,
    },
    {
        key: 'rec_current_fu_campaign',
        label: '(REC) FU Compaign (This time)',
        classNames: '',
        displayType: 'text',
        inputType: 'text',
        editable: true,
        autoAdd: false,
        capitalize: false,
        searchable: true,
        group: 4,
    },
    {
        key: 'rec_next_fu_schedule_date_time',
        label: '(REC) FU Schedule (Next time)',
        classNames: '',
        displayType: 'text',
        inputType: 'date',
        inputRange: true,
        editable: true,
        autoAdd: false,
        capitalize: false,
        searchable: true,
        group: 5,
    },
    {
        key: 'rec_next_fu_strategy_date_time',
        label: '(REC) FU Strategy (Next time)',
        classNames: '',
        displayType: 'text',
        inputType: 'text',
        inputRange: false,
        editable: true,
        autoAdd: false,
        capitalize: false,
        searchable: true,
        group: 5,
    },
    {
        key: 'rec_next_fu_campaign',
        label: '(REC) FU Compaign (Next time)',
        classNames: '',
        displayType: 'text',
        inputType: 'text',
        editable: true,
        autoAdd: false,
        capitalize: false,
        searchable: true,
        group: 5,
    },
    {
        key: 'notes',
        label: 'Notes',
        classNames: '',
        displayType: 'text',
        inputType: 'textarea',
        searchable: true,
        editable: true
    },
];

export const DVTJCUVPipelineTableSearchReceiverColumns = [
    // {
    //     key: 'id',
    //     label: 'Pipeline ID',
    //     classNames: '',
    //     displayType: 'text',
    //     inputType: 'number',
    //     editable: false,
    //     autoAdd: true,
    //     searchable: true
    // },
    // {
    //     key: 'created_date_time',
    //     label: 'Note time',
    //     classNames: '',
    //     displayType: 'text',
    //     inputType: 'date',
    //     editable: false,
    //     autoAdd: true,
    //     searchable: false
    // },
    {
        key: 'cdd_receiver_id',
        label: 'Cdd Receiver ID',
        classNames: '',
        displayType: 'link',
        inputType: 'number',
        editable: true,
        link: '/candidate/detail/',
        searchable: true
    },
    {
        key: 'cdd_receiver_full_name',
        label: 'Họ và tên',
        classNames: '',
        displayType: 'text',
        inputType: 'text',
        editable: false,
        autoAdd: true,
        capitalize: true,
        searchable: true
    },
    {
        key: 'cdd_receiver_displayed_company',
        label: 'Displayed Company',
        classNames: '',
        displayType: 'text',
        inputType: 'text',
        editable: false,
        capitalize: true,
        autoAdd: true,
        searchable: false
    },
    {
        key: 'cdd_receiver_displayed_title',
        label: 'Displayed Title',
        classNames: '',
        displayType: 'text',
        inputType: 'text',
        editable: false,
        capitalize: true,
        autoAdd: true,
        searchable: false
    },
    {
        key: 'cdd_receiver_local_province_email',
        label: 'Loca tỉnh (email)',
        classNames: '',
        displayType: 'text',
        inputType: 'text',
        editable: false,
        capitalize: true,
        autoAdd: true,
        searchable: false
    },
];


export const DVTJCUVPipelineSearchRecSummaryTableColumns = [
    {
        key: 'created_date_time',
        label: 'Note time',
        classNames: '',
        displayType: 'text',
        inputType: 'date',
        editable: false,
        autoAdd: true,
        searchable: false
    },
    {
        key: 'id',
        label: 'Pipeline ID',
        classNames: '',
        displayType: 'text',
        inputType: 'number',
        editable: false,
        autoAdd: true,
        searchable: true
    },
    {
        key: 'cdd_id',
        label: 'Cdd ID',
        classNames: '',
        displayType: 'link',
        inputType: 'number',
        editable: true,
        link: '/candidate/detail/',
        searchable: true
    },
    {
        key: 'cdd_full_name',
        label: 'Họ và tên',
        classNames: '',
        displayType: 'text',
        inputType: 'text',
        editable: false,
        autoAdd: true,
        capitalize: true,
        searchable: false
    },
    {
        key: 'cdd_displayed_company',
        label: 'Displayed Company',
        classNames: '',
        displayType: 'text',
        inputType: 'text',
        editable: false,
        capitalize: true,
        autoAdd: true,
        searchable: false
    },
    {
        key: 'cdd_displayed_title',
        label: 'Displayed Title',
        classNames: '',
        displayType: 'text',
        inputType: 'text',
        editable: false,
        capitalize: true,
        autoAdd: true,
        searchable: false
    },
    {
        key: 'employer_id',
        label: 'Employer',
        classNames: '',
        displayType: 'link',
        inputType: 'number',
        editable: false,
        link: '/employer/edit/',
        searchable: true,
        autoAdd: true,
        group: 6,
    },
    {
        key: 'employer_name',
        label: 'Employer Name',
        classNames: '',
        displayType: 'text',
        inputType: 'text',
        editable: false,
        searchable: false,
        autoAdd: true,
        group: 6,
    },
    {
        key: 'job_id',
        label: 'Job',
        classNames: '',
        displayType: 'link',
        inputType: 'number',
        editable: true,
        link: '/job/edit/',
        searchable: true,
        group: 7,
    },
    {
        key: 'job_name',
        label: 'Job Name',
        classNames: '',
        displayType: 'text',
        inputType: 'text',
        editable: false,
        searchable: false,
        autoAdd: true,
        group: 7,
    },
    {
        key: 'cdd_emp_process',
        label: 'Cdd-Emp Process',
        classNames: '',
        displayType: 'text',
        inputType: 'option',
        searchable: true,
        editable: true,
        isMulti: false,
        options: CddEmpProcessOptions,
        color: '',
        group: 7,
    },
    {
        key: 'notes',
        label: 'Notes',
        classNames: '',
        displayType: 'text',
        inputType: 'textarea',
        searchable: true,
        editable: true
    },
];

export const DVTJCUVPipelineSearchCddSummaryTableColumns = [
    {
        key: 'created_date_time',
        label: 'Note time',
        classNames: '',
        displayType: 'text',
        inputType: 'date',
        editable: false,
        autoAdd: true,
        searchable: false
    },
    {
        key: 'id',
        label: 'Pipeline ID',
        classNames: '',
        displayType: 'text',
        inputType: 'number',
        editable: false,
        autoAdd: true,
        searchable: true
    },
    {
        key: 'cdd_receiver_id',
        label: 'Cdd Receiver ID',
        classNames: '',
        displayType: 'link',
        inputType: 'number',
        editable: true,
        link: '/candidate/detail/',
        searchable: true
    },
    {
        key: 'cdd_receiver_full_name',
        label: 'Họ và tên',
        classNames: '',
        displayType: 'text',
        inputType: 'text',
        editable: false,
        autoAdd: true,
        capitalize: true,
        searchable: false,
        group: 6,
    },
    {
        key: 'cdd_receiver_displayed_company',
        label: 'Displayed Company',
        classNames: '',
        displayType: 'text',
        inputType: 'text',
        editable: false,
        capitalize: true,
        autoAdd: true,
        searchable: false,
        group: 6,
    },
    {
        key: 'cdd_receiver_displayed_title',
        label: 'Displayed Title',
        classNames: '',
        displayType: 'text',
        inputType: 'text',
        editable: false,
        capitalize: true,
        autoAdd: true,
        searchable: false,
        group: 6,
    },
    {
        key: 'employer_id',
        label: 'Employer',
        classNames: '',
        displayType: 'link',
        inputType: 'number',
        editable: false,
        link: '/employer/edit/',
        searchable: true,
        autoAdd: true,
        group: 6,
    },
    {
        key: 'employer_name',
        label: 'Employer Name',
        classNames: '',
        displayType: 'text',
        inputType: 'text',
        editable: false,
        searchable: false,
        autoAdd: true,
        group: 6,
    },
    {
        key: 'job_id',
        label: 'Job',
        classNames: '',
        displayType: 'link',
        inputType: 'number',
        editable: true,
        link: '/job/edit/',
        searchable: true,
        group: 7,
    },
    {
        key: 'job_name',
        label: 'Job Name',
        classNames: '',
        displayType: 'text',
        inputType: 'text',
        editable: false,
        searchable: false,
        autoAdd: true,
        group: 7,
    },
    {
        key: 'cdd_emp_process',
        label: 'Cdd-Emp Process',
        classNames: '',
        displayType: 'text',
        inputType: 'option',
        searchable: true,
        editable: true,
        isMulti: false,
        options: CddEmpProcessOptions,
        color: '',
        group: 7,
    },
    {
        key: 'notes',
        label: 'Notes',
        classNames: '',
        displayType: 'text',
        inputType: 'textarea',
        searchable: true,
        editable: true
    },
];

export const DVTJCUVPipelineSearchEmpSummaryTableColumns = [
    {
        key: 'created_date_time',
        label: 'Note time',
        classNames: '',
        displayType: 'text',
        inputType: 'date',
        editable: false,
        autoAdd: true,
        searchable: false
    },
    {
        key: 'id',
        label: 'Pipeline ID',
        classNames: '',
        displayType: 'text',
        inputType: 'number',
        editable: false,
        autoAdd: true,
        searchable: true
    },
    {
        key: 'cdd_id',
        label: 'Cdd ID',
        classNames: '',
        displayType: 'link',
        inputType: 'number',
        editable: true,
        link: '/candidate/detail/',
        searchable: true
    },
    {
        key: 'cdd_full_name',
        label: 'Họ và tên',
        classNames: '',
        displayType: 'text',
        inputType: 'text',
        editable: false,
        autoAdd: true,
        capitalize: true,
        searchable: false
    },
    {
        key: 'cdd_displayed_company',
        label: 'Displayed Company',
        classNames: '',
        displayType: 'text',
        inputType: 'text',
        editable: false,
        capitalize: true,
        autoAdd: true,
        searchable: false
    },
    {
        key: 'cdd_displayed_title',
        label: 'Displayed Title',
        classNames: '',
        displayType: 'text',
        inputType: 'text',
        editable: false,
        capitalize: true,
        autoAdd: true,
        searchable: false
    },
    {
        key: 'cdd_receiver_id',
        label: 'Cdd Receiver ID',
        classNames: '',
        displayType: 'link',
        inputType: 'number',
        editable: true,
        link: '/candidate/detail/',
        searchable: true
    },
    {
        key: 'cdd_receiver_full_name',
        label: 'Họ và tên',
        classNames: '',
        displayType: 'text',
        inputType: 'text',
        editable: false,
        autoAdd: true,
        capitalize: true,
        searchable: false,
        group: 6,
    },
    {
        key: 'cdd_receiver_displayed_company',
        label: 'Displayed Company',
        classNames: '',
        displayType: 'text',
        inputType: 'text',
        editable: false,
        capitalize: true,
        autoAdd: true,
        searchable: false,
        group: 6,
    },
    {
        key: 'cdd_receiver_displayed_title',
        label: 'Displayed Title',
        classNames: '',
        displayType: 'text',
        inputType: 'text',
        editable: false,
        capitalize: true,
        autoAdd: true,
        searchable: false,
        group: 6,
    },
    {
        key: 'job_id',
        label: 'Job',
        classNames: '',
        displayType: 'link',
        inputType: 'number',
        editable: true,
        link: '/job/edit/',
        searchable: true,
        group: 7,
    },
    {
        key: 'job_name',
        label: 'Job Name',
        classNames: '',
        displayType: 'text',
        inputType: 'text',
        editable: false,
        searchable: false,
        autoAdd: true,
        group: 7,
    },
    {
        key: 'cdd_emp_process',
        label: 'Cdd-Emp Process',
        classNames: '',
        displayType: 'text',
        inputType: 'option',
        searchable: true,
        editable: true,
        isMulti: false,
        options: CddEmpProcessOptions,
        color: '',
        group: 7,
    },
    {
        key: 'notes',
        label: 'Notes',
        classNames: '',
        displayType: 'text',
        inputType: 'textarea',
        searchable: true,
        editable: true
    },
];


export const MaxStepCddEmpProcess = {
    "": "",
    Blank: "Blank",
    Target: "Target",
    BriefSent: "Brief sent",
    EmpInterestWantDiscussMore: "Emp quan tâm ƯV, muốn trao đổi thêm",
    EmpShareJob: "Emp share job",
    CddCvSent: "Cdd's CV sent",
    EmpInvitesCddToItv: "Emp invites Cdd to ITV",
    Interviewing: "Interviewing",
    CddTaskPresentation: "Cdd làm bài tập, presentation,…",
    PreOfferProcedures: "Thủ tục trước khi offer (Ref Check, Pay slip,…)",
    VerbalOffer: "Verbal Offer",
    OfficialOffer: "Official Offer",
    CddAcceptsOffer: "Cdd accepts Offer",
    CddOnboard: "Cdd onboard"
};


export const MaxStepCddEmpProcessOptions = Object.values(MaxStepCddEmpProcess).map((item, index) => {
    return {
        value: index,
        label: item
    };
})

export const DVTJCUVPipelineSearchOnlyGet = {
    // AllRow: "Tất cả các dòng",
    LatestPipelineCdd: "Latest Pipeline (Cdd)",
    LatestPipelineRec: "Latest Pipeline (Rec)",
    LatestPipelineEmp: "Latest Pipeline (Emp)",
    LatestPipelineCddReceiver: "Latest Pipeline (Cdd-Receiver)",
    LatestPipelineCddEmployer: "Latest Pipeline (Cdd-Employer)",
}

export const DVTJCUVPipelineSearchOnlyGetOptions = Object.values(DVTJCUVPipelineSearchOnlyGet).map((item, index) => {
    return {
        value: item,
        label: item
    };
})

export const DVTJCUVPipelineSearchExcept = {
    // AllRows: "Trên tất cả các dòng",
    ExcludeEmailInviteUV: "Loại trừ các dòng Email gửi UV - mời",
    ExcludeEmailFUUV: "Loại trừ các dòng Email gửi UV - FU",
    ExcludeEmailBriefRec: "Loại trừ các dòng Email gửi Rec - Brief UV",
    ExcludeEmailFURec: "Loại trừ các dòng Email gửi Rec - FU",
    ExcludeEmailUpdateInfoRec: "Loại trừ các dòng Email gửi Rec - update info",
    ExcludeAllAboveEmails: "Loại trừ tất cả các email trên"
}

export const DVTJCUVPipelineSearchExceptOptions = Object.values(DVTJCUVPipelineSearchExcept).map((item, index) => {
    return {
        value: item,
        label: item
    };
})

export const D2HighlightFields = [
    'cdd_id',
    'service_use_times',
    'cdd_me_check_status',
    'interactive_channel',
    'gp_cdd_process',
    'us_qualify_cdd',
    'to_do_w_cdd',
    'current_fu_strategy_date_time',
    'current_fu_campaign',
    'notes',
    'note_with_cdd',
    'process_priority',
    'note_discussion_w_cdd',
    'cdd_receiver_me_check_status',
]

export const D1HighlightFields = [
    'cdd_id',
    'cdd_receiver_id',
    'cdd_me_check_status',
    'candidate_receive_request',
    'cdd_receiver_category'
]

export const DVTJCUVPipelineBlock = {
    ConnectCddEmpManager: "connect-cdd-emp-manager",
    AcquireCddManager: "acquire-cdd-manager",
    CddOpenAndNotSddvManager: "cdd-open-and-not-sddv-manager",

}